import { render } from "./SliderAwardHome.vue?vue&type=template&id=1c96278a&scoped=true"
import script from "./SliderAwardHome.vue?vue&type=script&lang=js"
export * from "./SliderAwardHome.vue?vue&type=script&lang=js"

import "./SliderAwardHome.vue?vue&type=style&index=0&id=1c96278a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c96278a"]])

export default __exports__